import { regexForm } from 'components/utils/regexForm'
import { validationCNPJ, validationCPF } from 'components/utils/validationsFN'
import formatter from 'utils/formatter'
import * as yup from 'yup'

export const Schema = yup.object({
    data: yup
        .object({
            cnpj: yup
                .string()
                .required()
                .matches(regexForm.cnpj)
                .transform(value => formatter.cnpj(value))
                .test({
                    name: 'invalid',
                    test: value => !!value && validationCNPJ(value as string)
                }),
            razaoSocial: yup.string().required().min(3),
            IE: yup.string(),
            IM: yup.string(),
            email: yup.string().required().email(),
            contato: yup
                .string()
                .required()
                .transform(value => formatter.contato(value))
                .matches(regexForm.contato)
        })
        .required(),
    address: yup
        .object()
        .shape({
            form: yup
                .array()
                .of(
                    yup.object().shape({
                        cep: yup
                            .string()
                            .required()
                            .matches(/[0-9]{5}-[0-9]{3}/),
                        logradouro: yup.string().required(),
                        numero: yup.string().required(),
                        municipio: yup.string().required(),
                        bairro: yup.string().required(),
                        uf: yup.string().required(),
                        complementoo: yup.string(),
                        tipoEndereco: yup
                            .string()
                            .required('Tipo é um campo obrigatório')
                    })
                )
                .required()
        })
        .required(),
    responsible: yup
        .object()
        .shape({
            form: yup
                .array()
                .of(
                    yup.object().shape({
                        nome: yup.string().min(3).required(),
                        cpf: yup
                            .string()
                            .required()
                            .matches(regexForm.cpf)
                            .test({
                                name: 'invalid',
                                test: value =>
                                    !!value && validationCPF(value as string)
                            }),
                        contato: yup
                            .string()
                            .required()
                            .transform(value => formatter.contato(value))
                            .matches(regexForm.contato)
                    })
                )
                .required()
        })
        .required()
})
